module.exports = function() {
  return new Worker(__webpack_public_path__ + "2ab01210a5d3d964e925.worker.js");
};